/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityProviderSettingsState
 */
export interface IdentityProviderSettingsState {
    /**
     * 
     * @type {string}
     * @memberof IdentityProviderSettingsState
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityProviderSettingsState
     */
    disabled?: boolean;
}

export function IdentityProviderSettingsStateFromJSON(json: any): IdentityProviderSettingsState {
    return IdentityProviderSettingsStateFromJSONTyped(json, false);
}

export function IdentityProviderSettingsStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityProviderSettingsState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function IdentityProviderSettingsStateToJSON(value?: IdentityProviderSettingsState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


